import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetohyderabadcab() {



const cardData = {
  keyword: " Pune to Hyderabad Cabs ",

"headingDescription": "SRS Cab Service offers Pune to Hyderabad Cabs, providing a comfortable, safe, and long-distance travel solution for families, business travelers, and groups. Our well-maintained vehicles, experienced drivers, and timely pickups ensure a smooth and hassle-free journey from Pune to Hyderabad. Ideal for business trips, family travel, and intercity journeys, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and reliable travel experience.",
"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar is the most iconic landmark of Hyderabad known for its historic architecture. Travelers using SRS Cab Service from Pune often visit this monument to explore the city’s heritage and local markets."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a historic fortress famous for its acoustics and architecture. Visitors using SRS Cab Service often explore this fort to enjoy panoramic views and learn about its rich history."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City is one of the largest film studio complexes in the world. Travelers using SRS Cab Service often include this attraction for entertainment, tours, and family fun."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Hussain Sagar Lake is a popular spot known for its large Buddha statue. Visitors using SRS Cab Service often enjoy boating and scenic views here."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a beautiful temple dedicated to Lord Venkateswara. Travelers using SRS Cab Service often visit this peaceful location for spiritual experience and city views."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum houses one of the largest art collections in India. Visitors using SRS Cab Service often explore this museum to see rare artifacts and historical items."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace is a royal palace reflecting the grandeur of the Nizams. Travelers using SRS Cab Service often visit to admire its architecture and heritage."
  },
  {
    "title": "Nehru Zoological Park",
    "description": "Nehru Zoological Park is a large zoo with a variety of wildlife. Visitors using SRS Cab Service often include this destination for family outings and nature exploration."
  },
  {
    "title": "Lumbini Park",
    "description": "Lumbini Park is a scenic park near Hussain Sagar Lake known for its laser shows. Travelers using SRS Cab Service often relax here and enjoy evening entertainment."
  },
  {
    "title": "Shilparamam",
    "description": "Shilparamam is a cultural village showcasing traditional crafts and art. Visitors using SRS Cab Service often explore this place for shopping and cultural experiences."
  }
],



services: [
{
name: "Pune to Hyderabad Cabs",
description: "Pune to Hyderabad cabs offer reliable long-distance travel for business and leisure trips. Customers can book cabs for comfortable journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Hyderabad with cab services."
},
{
name: "Pune to Hyderabad Taxi Booking",
description: "Pune to Hyderabad taxi booking provides quick and easy reservation options. Customers can book taxis online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily for Hyderabad travel."
},
{
name: "Pune to Hyderabad Car Rental",
description: "Pune to Hyderabad car rental offers flexible travel options for long-distance trips. Customers can rent cars for family and business travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars easily from Pune."
},
{
name: "Pune to Hyderabad Taxi Rates",
description: "Pune to Hyderabad taxi rates provide clear pricing details for travelers. Customers can compare rates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent rates."
},
{
name: "Pune to Hyderabad Cab Charges",
description: "Pune to Hyderabad cab charges offer detailed pricing for travel planning. Customers can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent charges."
},
{
name: "Pune to Hyderabad Cab Pricing",
description: "Pune to Hyderabad cab pricing provides a complete cost breakdown for trips. Customers can compare pricing options before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with transparent pricing."
},
{
name: "Pune to Hyderabad Private Car Hire",
description: "Pune to Hyderabad private car hire offers personalized travel for families and corporate trips. Customers can hire vehicles for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with private car hire services."
},
{
name: "Pune to Hyderabad Cab Cost",
description: "Pune to Hyderabad cab cost provides estimated pricing for travelers. Customers can check trip cost before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab cost services."
},
{
name: "Pune to Hyderabad Taxi Service",
description: "Pune to Hyderabad taxi service offers dependable transportation for long-distance travel. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab from Pune to Hyderabad",
description: "Cab from Pune to Hyderabad provides convenient travel for intercity journeys. Customers can book cabs for business and leisure trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Hyderabad Taxi",
description: "Pune to Hyderabad taxi offers reliable transportation for long-distance travel. Customers can book taxis for flexible trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Hyderabad Airport Cab",
description: "Pune to Hyderabad airport cab offers convenient airport transfer services. Customers can book cabs for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Pune to Telangana Cab Service",
description: "Pune to Telangana cab service provides reliable travel across major cities in Telangana. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Mysore Ooty Package",
description: "Pune to Mysore Ooty package offers extended travel for scenic tours. Customers can book packages for multi-day trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with tour packages."
},
{
name: "Pune to Hyderabad Innova Crysta",
description: "Pune to Hyderabad Innova Crysta offers premium SUV travel for comfort. Customers can enjoy spacious seating and luggage space. Professional drivers ensure safe journeys. Ideal for family trips. Transparent pricing ensures value for money. Travel comfortably with Innova Crysta."
},
{
name: "Pune to Hyderabad Tempo Traveller on Rent",
description: "Pune to Hyderabad tempo traveller on rent offers group travel solutions. Customers can book spacious vehicles for family and corporate trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Pune to Hyderabad Sedan Cabs",
description: "Pune to Hyderabad sedan cabs provide affordable travel for individuals and small groups. Customers can book vehicles for budget-friendly journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Pune to Hyderabad Cab Service",
description: "Pune to Hyderabad cab service offers reliable transportation for long-distance journeys. Customers can book cabs for flexible trips. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Hyderabad Taxi Service",
description: "Pune to Hyderabad taxi service provides convenient travel options for intercity trips. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Hyderabad Cab Booking",
description: "Pune to Hyderabad cab booking provides quick reservation options for travelers. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily."
},
{
name: "Pune to Hyderabad Taxi Booking",
description: "Pune to Hyderabad taxi booking offers easy booking options for travelers. Customers can reserve taxis instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily."
},
{
name: "Pune to Hyderabad One Way Cab",
description: "Pune to Hyderabad one way cab offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one-way cab services."
},
{
name: "Pune to Hyderabad One Way Taxi",
description: "Pune to Hyderabad one way taxi provides convenient travel for single-direction journeys. Customers can book taxis easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one-way taxi services."
},
{
name: "Pune to Hyderabad Cab Fare",
description: "Pune to Hyderabad cab fare provides detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
}
],

tableData: [
["Pune to Hyderabad Cabs","Pune to Hyderabad Taxi Booking"],
["Pune to Hyderabad Car Rental","Pune to Hyderabad Taxi Rates"],
["Pune to Hyderabad Cab Charges","Pune to Hyderabad Cab Pricing"],
["Pune to Hyderabad Private Car Hire","Pune to Hyderabad Cab Cost"],
["Pune to Hyderabad Taxi Service","Cab from Pune to Hyderabad"],
["Pune to Hyderabad Taxi","Pune to Hyderabad Airport Cab"],
["Pune to Telangana Cab Service","Pune to Mysore Ooty Package"],
["Pune to Hyderabad Innova Crysta","Pune to Hyderabad Tempo Traveller on Rent"],
["Pune to Hyderabad Sedan Cabs","Pune to Hyderabad Cab Service"],
["Pune to Hyderabad Taxi Service","Pune to Hyderabad Cab Booking"],
["Pune to Hyderabad Taxi Booking","Pune to Hyderabad One Way Cab"],
["Pune to Hyderabad One Way Taxi","Pune to Hyderabad Cab Fare"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "SRS Cab Service provides expert drivers experienced in Pune to Hyderabad routes, ensuring safe highway driving, proper rest planning, and smooth intercity travel."
  },
  {
    WhyChooseheading: "Affordable Pune to Hyderabad Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Hyderabad cab services with transparent pricing. Customers receive complete fare details including tolls, state taxes, and driver allowance with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Hyderabad cab bookings, making it convenient for business travel, family trips, and urgent long-distance journeys."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles designed for long-distance comfort, ensuring a relaxed journey from Pune to Hyderabad."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide one-way cab service, round-trip bookings, and customized travel plans for Pune to Hyderabad journeys based on customer requirements."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for individual, family, and corporate travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Hyderabad cab bookings due to punctual service, professional drivers, and reliable vehicles for long-distance travel."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Hyderabad cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Hyderabad for long-distance travel." },
  { question: "How far is Hyderabad from Pune?", answer: "The distance between Pune and Hyderabad is approximately 560 km and the journey takes around 10 to 12 hours depending on route and traffic." },
  { question: "Is Pune to Hyderabad cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Pune to Hyderabad travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Hyderabad?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide multi-day travel options?", answer: "Yes, we offer customized multi-day travel plans for Pune to Hyderabad journeys." },
  { question: "Are vehicles suitable for long-distance travel?", answer: "Yes, all vehicles are well-maintained and suitable for long-distance journeys." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Hyderabad cab service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ramesh Patil",
    feedback:
      "Booked SRS Cab Service for Pune to Hyderabad trip. Long journey was very smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Neha Sharma",
    feedback:
      "Excellent Pune to Hyderabad cab service. Reliable and perfect for long-distance travel.",
    rating: 5
  }
];




























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Hyderabad Cab | SRS Cab",
  "description": "Book Pune to Hyderabad cabs with SRS Cab. One-way, round trips, and private car hire available. Travel comfortably with Innova, Sedan, Tempo Traveller, or other vehicles. Affordable taxi services with 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2150"
  }
};








  return (
    <div>
      <Helmet>
  <title>Pune to Hyderabad Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="SRS Cab offers Pune to Hyderabad cab services including one-way, round trips, and private car hire. Travel with Innova, Sedan, or Tempo Traveller. Affordable, reliable, and 24x7 online booking available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/45.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetohyderabadcab;